// /src/pages/admin/FeedbackPage.tsx
import React, { useEffect, useState } from "react";
import { getFeedbacks, deleteFeedback } from "../../lib/firebase/firestore";
import styles from "../../styles/AdminTable.module.css";

type Feedback = {
  id: string;
  rating: number;
  review: string;
  createdAt: any;
};

export const FeedbackPage = () => {
  const [feedbacks, setFeedbacks] = useState<Feedback[]>([]);
  const [loading, setLoading] = useState(false);

  // Fetch feedbacks
  const fetchFeedbacks = async () => {
    const data = await getFeedbacks();
    setFeedbacks(data);
  };

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  // Delete feedback
  const handleDelete = async (id: string) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this feedback?"
    );
    if (!confirmDelete) return;

    try {
      setLoading(true);
      await deleteFeedback(id);
      // Remove deleted feedback from state
      setFeedbacks((prev) => prev.filter((f) => f.id !== id));
    } catch (error) {
      console.error("Error deleting feedback:", error);
      alert("Failed to delete feedback. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>User Feedback</h2>
      {feedbacks.length === 0 ? (
        <p>No feedbacks yet.</p>
      ) : (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Rating</th>
              <th>Review</th>
              <th>Submitted</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {feedbacks.map((f) => (
              <tr key={f.id}>
                <td>{f.rating} ⭐</td>
                <td>{f.review}</td>
                <td>
                  {f.createdAt?.toDate
                    ? f.createdAt.toDate().toLocaleString()
                    : ""}
                </td>
                <td>
                  <button
                    onClick={() => handleDelete(f.id)}
                    disabled={loading}
                    className={styles.deleteButton}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
